export default __webpack_public_path__ + "static/media/notification.462b5469.svg";